module.exports = __webpack_public_path__ + "static/media/success.ebd2c523.png";